<template>
  <div class="detail_main bg_detail is-scrollable has-background-white">
    <div class="detail_img_info" v-if="detailResauxComplet.listeFaces.length">
      <div class="level is-mobile diapo_mount">
        <div class="level-left is-marginless">
          <a class="button has-text-white is-rounded diapo_button"
            @click="$parent.show = false">
            <span class="icon">
              <b-icon icon="chevron-left"></b-icon>
            </span>
            <label>Retour</label>
          </a>
        </div>
        <div class="level-right">
          <div class="button has-text-white is-rounded rightViolet diapo_count">
            <label>{{currentImg + 1}}/{{detailResauxComplet.listeFaces.length}}</label>
          </div>
        </div>
      </div>
      <img
        :src="url(img)"
        class="imageBgOpp imgGoToTop"
        v-touch:swipe.left="swipeLeft()"
        v-touch:swipe.right="swipeRight()">
    </div>
    <div class="detail_img_info" v-else>
      <a
        class="button has-text-white is-rounded diapo_button"
        @click="$parent.show = false">
        <span class="icon">
          <b-icon
            icon="chevron-left">
          </b-icon>
        </span>
        <label>Retour</label>
      </a>
      <img :src="url(detailResauxComplet.urlPhoto)" class="imageBgOpp imgGoToTop">
    </div>
    <div class="leftVert topViolet rightVert bottomVert">
      <div class="tabs bottomVert">
        <ul class="p_size12 has-text-weight-bold">
          <li :class="{'underline is-active': active === 1}"
              @click="active = 1"
              class="is-paddingless">
            <a>Proposition</a>
          </li>
          <li :class="{'underline is-active': active === 2}"
              @click="active = 2"
              class="is-paddingless">
            <a>Caractéristiques</a>
          </li>
        </ul>
      </div>
      <div class="columns is-mobile is-multiline is-marginless color-icon"
           v-if="active === 1">
         <div v-if="detailResauxComplet.extensionOpportunite.duree"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="timer"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Durée
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{detailResauxComplet.extensionOpportunite.duree}}
                </p>
              </div>
            </div>
          </div>
          <div v-if="detailResauxComplet.extensionOpportunite.tarifNet"
              class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="cash"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Tarif Net HT
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{tarif(detailResauxComplet.extensionOpportunite.tarifNet)}}
                  {{this.detailResauxComplet.extensionOpportunite.tarifInformation}}
                </p>
                <span class="has-text-grey is-italic"
                  v-if="detailResauxComplet.extensionOpportunite.masquerRemiseEdition === true
                    && this.detailResauxComplet.extensionOpportunite.remise">
                  {{this.detailResauxComplet.extensionOpportunite.remise}} {{typeRemise}}
                </span>
              </div>
            </div>
          </div>
          <div v-if="detailResauxComplet.extensionOpportunite.tarifBrut"
              class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="cash"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Tarif Brut HT
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{tarif(detailResauxComplet.extensionOpportunite.tarifBrut)}}
                  {{this.detailResauxComplet.extensionOpportunite.tarifInformation}}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailResauxComplet.extensionOpportunite.fraisTechnique"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="panorama-wide-angle"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Frais techniques HT
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{tarif(detailResauxComplet.extensionOpportunite.fraisTechnique)}}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailResauxComplet.extensionOpportunite.tarifDePose"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="sign-text"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Frais de pose HT
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{tarif(detailResauxComplet.extensionOpportunite.tarifDePose)}}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailResauxComplet.extensionOpportunite.taxeMunicipale"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="ballot"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Taxes municipales
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{tarif(detailResauxComplet.extensionOpportunite.taxeMunicipale)}}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailResauxComplet.extensionOpportunite.date"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="calendar"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Disponible le
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{date}}
                </p>
              </div>
            </div>
          </div>
          <div v-if="detailResauxComplet.extensionOpportunite.commentaire">
          <h3 class="has-text-weight-bold topViolet bottomViolet has-text-link">
            Commentaire:</h3>
          <div class="commentaire">
            <p class="has-text-link has-text-justify p_size12">
              {{detailResauxComplet.extensionOpportunite.commentaire}}
            </p>
          </div>
        </div>
      </div>
      <div v-if="active === 2">
        <div class="columns is-mobile is-multiline is-marginless color-icon">
            <div class="column is-6">
              <div class="media">
                <b-icon
                  icon="city"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content is-size-7">
                  <label class="has-text-default">
                    Ville
                  </label><br>
                  <p class="p_size12 has-text-weight-bold has-text-link">
                    {{detailResauxComplet.ville}}
                  </p>
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="media">
                <b-icon
                  icon="vector-intersection"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content is-size-7">
                <label class="has-text-default">
                  Format
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{detailResauxComplet.format}}
                </p>
                </div>
              </div>
            </div>
            <div class="column is-6" v-if="detailResauxComplet.nbFaces">
              <div class="media">
                <b-icon
                  icon="sign-text"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content is-size-7">
                  <label class="has-text-default">
                    Nombre de faces
                  </label><br>
                  <p class="p_size12 has-text-weight-bold has-text-link">
                    {{detailResauxComplet.nbFaces}}
                  </p>
                </div>
              </div>
            </div>
          </div>
      </div>
      <div v-if="!detailResauxComplet.select" @click="contolSelect()"
        class="navbar is-fixed-bottom button is-primary boutonSelectM has-text-weight-bold">
        <p class="p_size11 centreM">Ajouter a ma sélection</p>
      </div>
      <div v-else @click="contolSelect()"
        class="navbar is-fixed-bottom button boutonRed boutonSelectM has-text-weight-bold">
        <p class="p_size11 centreM">Retirer de ma sélection</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { urlPhoto, formatNum, formatDate } from '@/services/opportunite/formatTab';

export default {
  name: 'detailReseauxLcCompletDiapo',
  props: ['detailResauxComplet'],
  data() {
    return {
      show: false,
      hoverButton: false,
      active: 1,
      select: true,
      currentImg: 0,
    };
  },
  computed: {
    date() {
      return formatDate(this.detailResauxComplet.extensionOpportunite.date);
    },
    img() {
      return this.detailResauxComplet.listeFaces[this.currentImg].urlPhoto;
    },
    typeRemise() {
      if (this.detailResauxComplet.extensionOpportunite.typeDeRemise === 0) {
        return '% de remise inclus';
      }
      return '€ de remise inclus';
    },
    getTarif() {
      let tarifNet = 0;
      let tarifDePose = 0;
      let taxeMunicipale = 0;
      let fraisTechnique = 0;
      let tarifBrut = 0;
      if (this.detailResauxComplet.extensionOpportunite.tarifDePose) {
        tarifDePose = this.detailResauxComplet.extensionOpportunite.tarifDePose;
      }
      if (this.detailResauxComplet.extensionOpportunite.taxeMunicipale) {
        taxeMunicipale = this.detailResauxComplet.extensionOpportunite.taxeMunicipale;
      }
      if (this.detailResauxComplet.extensionOpportunite.fraisTechnique) {
        fraisTechnique = this.detailResauxComplet.extensionOpportunite.fraisTechnique;
      }
      if (this.detailResauxComplet.extensionOpportunite.tarifBrut) {
        tarifBrut = this.detailResauxComplet.extensionOpportunite.tarifBrut;
      }
      if (this.detailResauxComplet.extensionOpportunite.tarifNet) {
        tarifNet = this.detailResauxComplet.extensionOpportunite.tarifNet;
        return tarifNet
        + tarifDePose
        + taxeMunicipale
        + fraisTechnique;
      }
      return tarifBrut
        + tarifDePose
        + taxeMunicipale
        + fraisTechnique;
    },
  },
  methods: {
    ...mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    contolSelect() {
      this.detailResauxComplet.select = !this.detailResauxComplet.select;
      if (this.detailResauxComplet.select) {
        this.add(this.getTarif);
        this.addNbSelect();
      } else {
        this.substract(this.getTarif);
        this.substractNbSelect();
      }
    },
    tarif(t) {
      return formatNum(t);
    },
    close() {
      this.$parent.show = false;
    },
    url(data) {
      return urlPhoto(data);
    },
    swipeLeft() {
      return () => {
        if (this.currentImg === this.detailResauxComplet.listeFaces.length - 1) {
          this.currentImg = 0;
        } else {
          this.currentImg += 1;
        }
      };
    },
    swipeRight() {
      return () => {
        if (this.currentImg === 0) {
          this.currentImg = this.detailResauxComplet.listeFaces.length - 1;
        } else {
          this.currentImg -= 1;
        }
      };
    },
  },
  mounted() {
    const test = document.querySelector('html');
    const test2 = document.querySelector('body');
    test.style.overflow = 'hidden';
    test2.style.overflow = 'hidden';
  },
  destroyed() {
    const test = document.querySelector('html');
    const test2 = document.querySelector('body');
    test.style.overflow = '';
    test2.style.overflow = '';
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/reseauxLc/detailReseauxLcCompletDiapo.vue